export const formatCurrency = (
  amount: number,
  currencyCode = "USD",
): string => {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
